import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: true,
};

const SideBarSlice = createSlice({
  name: 'sideBar',
  initialState,
  reducers: {
    toggleSideBar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { toggleSideBar } = SideBarSlice.actions;

export default SideBarSlice.reducer;
